import script from "./report-3.vue?vue&type=script&setup=true&lang=js"
export * from "./report-3.vue?vue&type=script&setup=true&lang=js"

import "./report-3.vue?vue&type=style&index=0&id=392b2686&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392b2686"]])

export default __exports__